import React, { useEffect, useState } from "react";
import { useParams, useHistory } from "react-router-dom";

import ExceptionCategoryService from "../../../../services/ExceptionCategoryService";
import ExceptionCategoryForm from "./forms/ExceptionCategoryForm";

function ExceptionCategoryAddEdit() {
  const { id } = useParams();
  let history = useHistory();

  const [formData, setData] = useState({
    ecrcT_ID: -1,
    endingColorCount: 0,
    exception_Deco: "",
    exception_Pcat: "",
    runChargeType: "",
    startingColorCount: 0,
  });

  const getData = async () => {
    const result = await ExceptionCategoryService.getOne(id);
    if (result) setData(result);
  };

  useEffect(() => {
    getData();
  }, []);

  const saveHandler = async (data) => {
    const postData = {
      Id: id,
      ExceptionDeco: data.exception_Deco,
      ExceptionPcat: data.exception_Pcat,
      StartingColorCount: data.startingColorCount,
      EndingColorCount: data.endingColorCount,
      RunChargeType: data.runChargeType,
    };

    if (id) {
      const result = await ExceptionCategoryService.update(postData);
      if (result.success === true) history.goBack();
    } else {
      const result = await ExceptionCategoryService.add(postData);
      if (result.success === true) history.goBack();
    }
  };

  return (
    <div>
      <h4>{id ? "Edit" : "New"} Exception Category</h4>
      <hr />
      <ExceptionCategoryForm formData={formData} submitForm={saveHandler} />
    </div>
  );
}

export default ExceptionCategoryAddEdit;
